import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-region',
  imports: [ReactiveFormsModule],
  templateUrl: './region.html',
  styleUrl: './region.scss',
})
export class Region {
  private locale = inject(LOCALE_ID);
  pharmacyForm = input.required<FormGroup>();
  regions = input.required<{ id: number; titleAr?: string; titleEn: string; profileImageFid?: string }[]>();

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
